import React from "react";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import axios from 'axios';
import Loader from 'react-loader-spinner';
import UserToolbarSelect from "../toolbar/UserToolbarSelect";
import {addUsers} from "actions/index";

const columns = [
    {
        name: "name",
        label: "Name",
        options: {
            filter: true,
            sort: true
        }
    },

    {
        name: "surname",
        label: "Surname",
        options: {
            filter: true,
            sort: true
        }
    },
    {
        name: "email",
        label: "Email Address",
        options: {
            filter: true,
            sort: true
        }
    },
    {
        name: "contact_number",
        label: "Contact Number",
        options: {
            filter: true,
            sort: true
        }
    }, {
        name: "role",
        label: "Role",
        options: {
            filter: true,
            sort: true
        }
    }, {
        name: "created_at",
        label: "Created At",
        options: {
            filter: true,
            sort: true
        }
    }
];

const options = {
    filterType: 'checkbox',
    customToolbarSelect: selectedRows => (
        <UserToolbarSelect selectedRows={selectedRows}/>
    )
};

const mapStateToProps = state => ({
    users: state.users,
    refresh_users: state.refresh_users
  });

  function mapDispatchToProps(dispatch) {
    return {
      addUsers: users => dispatch(addUsers(users))
    };
  }

class UsersTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            table_data: [],
            tableDataLoading: true,
            refresh_users: props.refresh_users
        };
        this.getUsers = this.getUsers.bind(this);
        this.parseTableData = this.parseTableData.bind(this);
    }

    componentDidMount() {
        //console.log('checking users tables', this.props);
        this.getUsers();
    }

    componentWillReceiveProps(){
        //console.log('Check hit heeeeree',this.props);
        //console.log('Check hit heeeeree',this.state);
        if(this.props.refreshUsersTable){
            this.getUsers();
        }
    }

    getUsers() {
        let token = localStorage.getItem('access_token');
        //console.log('getting users');
        let cur = this;
        axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/get-users', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            //console.log('current users', res.data);
            cur.setState({users: res.data.users});
            cur.props.addUsers(res.data.users);
            cur.parseTableData();            
        }).catch(error => {
            //console.log('error', error);
        });
    }

    parseTableData() {
       
        let data = this.state.users.map((prop, key) => {
            return [
                prop.name,
                prop.surname,
                prop.email,
                prop.contact_number,
                prop.roles[0].name,
                prop.created_at
            ];
        });
        //console.log("prop check", data);
        var filtered = data.filter(function (el) {
            return el != null;
        });
        //console.log('checkdata', this.state);
        this.setState({table_data: filtered, tableDataLoading: false});
    }

    render() {
        return(this.state.tableDataLoading ? <Loader type="Puff" color="#00BFFF"
            height={100}
            width={100}
            timeout={3000}
            //3 secs
        /> : <MUIDataTable title={
                'System Users'
            }
            data={
                this.state.table_data
            }
            columns={columns}
            options={options}/>);

    }

}
export default connect(mapStateToProps,mapDispatchToProps)(UsersTable);
